import {createAction, props} from '@ngrx/store';
import {ProleisObject} from '@proleis/proleis-rest-client';

export const incidentsFeatureKey = 'incidents';

export const LOAD_INCIDENTS = createAction(
  '[Incidents] Load incidents',
  props<{ orderId: string, posId: string, aliasFields?: string, zqlWhere?: string }>()
);

export const LOAD_INCIDENTS_SUCCESS = createAction(
  '[Incidents] Incidents successfully loaded',
  props<{ incidents: ProleisObject[] }>()
);

export const LOAD_INCIDENTS_ERROR = createAction(
  '[Incidents] error while loading incidents'
);

export const SELECT_INCIDENT = createAction(
  '[Incidents] Select incident',
  props<{ orderId: string, posId: string, incidentId: string, aliasFields?: string }>()
);

export const SELECT_INCIDENT_SUCCESS = createAction(
  '[Incidents] Selected incident',
  props<{ incident: ProleisObject }>()
);

export const SELECT_INCIDENT_ERROR = createAction(
  '[Incidents] Error while selecting incident'
);

export const LOAD_INCIDENT_DOCUMENTS = createAction(
  '[Incidents] Load incident documents',
  props<{ orderId: string, posId: string, incidentId: string, aliasFields?: string }>()
);

export const LOAD_INCIDENT_DOCUMENTS_SUCCESS = createAction(
  '[Incidents] Documents successfully loaded',
  props<{ documents: ProleisObject[] }>()
);

export const LOAD_INCIDENT_DOCUMENTS_ERROR = createAction(
  '[Incidents] Error while loading documents'
);

export const LOAD_INCIDENT_COMMENTS = createAction(
  '[Incidents] Load incident comments',
  props<{ orderId: string, posId: string, incidentId: string, aliasFields?: string }>()
);

export const LOAD_INCIDENT_COMMENTS_SUCCESS = createAction(
  '[Incidents] Comments successfully loaded',
  props<{ comments: ProleisObject[] }>()
);

export const LOAD_INCIDENT_COMMENTS_ERROR = createAction(
  '[Incidents] Error while loading comments'
);

export const ACCEPT_INCIDENT = createAction(
  '[Incidents] accept incident',
  props<{ incidentId: string, orderId: string, posId: string, aliasFields?: string }>()
);

export const ACCEPT_INCIDENT_SUCCESS = createAction(
  '[Incident] Incident accepted',
  props<{ incidentId: string, orderId: string, posId: string, aliasFields?: string }>()
);

export const ACCEPT_INCIDENT_ERROR = createAction(
  '[Incident] Error while accepting incident'
);

export const ADD_COMMENT = createAction(
  '[Incident] Adding comment',
  props<{ incidentId: string, comment: string }>()
);

export const ADD_COMMENT_SUCCESS = createAction(
  '[Incident] Comment added'
);

export const ADD_COMMENT_ERROR = createAction(
  '[Incident] Error while adding comment'
);

export const INCIDENT_ACCEPT_CHANGE = createAction(
  '[Incident] accepting change...',
  props<{ incidentId: string, orderId: string, posId: string, aliasFields: string }>()
);

export const INCIDENT_ACCEPT_CHANGE_SUCCESS = createAction(
  '[Incident] change accepted',
  props<{ incidentId: string, orderId: string, posId: string, aliasFields: string }>()
)
